import React from 'react'
import {
  MdKeyboardArrowDown as DownIcon,
  MdRoomService as BellIcon,
  MdShoppingBasket as CartIcon
} from 'react-icons/md'
import Loading from '@components/Loading'
import sleep from '@helpers/misc/sleep'
import formatNumber from '@i18n/formatNumber'
import FormatNumber from '@i18n/formatNumber/Component'
import {TFunction, withTranslation} from 'next-i18next'

import styles from './styles.module.css'

export interface CartMenuProps {
  open: boolean
  onClick: Function
  cart: any
  preferences: any
  t: TFunction
}

export class CartMenu extends React.Component<CartMenuProps> {
  state = {className: '', showMessage: 'close'}

  componentDidUpdate(prevProps, prevState) {
    const {cart} = this.props
    const {cart: prevCart} = prevProps
    if (!prevCart) return // First load, skip animation

    const total = (cart && cart.totalPrice) || 0
    const prevTotal = (prevCart && prevCart.totalPrice) || 0
    if (total > prevTotal) {
      this.attention()
    }

    if (!prevTotal && total) {
      this.showMessage()
    }
  }

  async attention() {
    this.setState({className: 'animated shake'})
    await sleep(1000)
    this.setState({className: 'animated'})
  }

  async showMessage() {
    this.setState({showMessage: 'show'})
    await sleep(3000)
    this.setState({showMessage: 'hide'})
    await sleep(1000)
    this.setState({showMessage: 'close'})
  }

  renderLabelExtra() {
    const {preferences} = this.props
    if (preferences.deliveryType !== 'serve') return
    if (!preferences.tableName) return
    return `, Mesa ${preferences.tableName}`
  }

  renderTotal({preferences, cart, total}) {
    const {tableName, orderGroup} = preferences
    if (tableName && orderGroup && orderGroup.tableTotal) {
      return (
        <>
          <div>Total mesa</div>
          <div>
            <BellIcon size={20} aria-label="cart" />
            <FormatNumber value={orderGroup.tableTotal} />
          </div>
        </>
      )
    } else if (cart) {
      return formatNumber(total, 'money')
    }

    return <Loading />
  }

  renderCartIcon() {
    if (this.props.preferences.tableName) return null

    return (
      <div className={styles.cartIcon}>
        <CartIcon size={20} aria-label="cart" />
      </div>
    )
  }

  render() {
    const {open, onClick, cart, preferences} = this.props
    const total = (cart && cart.itemsPrice) || 0
    if (open) {
      return (
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'Function' is not assignable to type 'MouseEv... Remove this comment to see the full error message
        <div className={styles.cartMenuClose} onClick={onClick}>
          Cerrar
        </div>
      )
    }

    const openClassName = total > 0 ? styles.cartHightlightMobile : ''

    return (
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'Function' is not assignable to type 'MouseEv... Remove this comment to see the full error message
      <div className={openClassName + ' ' + styles.cartMenuOpen} onClick={onClick}>
        <div>
          {this.props.t('order.cart.cartMenu.labelMyOrder', {name: this.renderLabelExtra()})}
        </div>
        {this.props.preferences.tableName ? null : (
          <div className={styles.icon}>
            <DownIcon size={22} />
          </div>
        )}
        <div className={styles.divider} />
        <div className={styles.cart}>
          <div className={styles.total + ' ' + this.state.className}>
            {this.renderTotal({preferences, cart, total})}
          </div>
          {this.renderCartIcon()}
        </div>
        {this.state.showMessage !== 'close' ? (
          <div className={this.state.showMessage === 'show' ? styles.message : styles.messageHide}>
            <div className={styles.arrowWrapper}>
              <div className={styles.arrowUp} />
            </div>
            {this.props.t('order.titleOrderContinue')}
          </div>
        ) : null}
      </div>
    )
  }
}

export default withTranslation()(CartMenu)
